module.exports = __webpack_public_path__ + "de_CH-header-9d9895.webp";